export default __webpack_public_path__ + "static/media/announcement_4.26c57be4.png";